module.exports = __webpack_public_path__ + "img/card-dragon-tiger.90448eb.jpg";